'use client'

import Image from 'next/image'
import { TbArrowUpRight, TbRosetteDiscountCheck } from 'react-icons/tb'
import AffiliateLink from '@/components/common/AffiliateLink'
import { OfferView } from '@/lib/affiliates/trackOfferView'
import { buildProviderLink } from '@/utils/blog/providerLinkHelpers'
import { isProviderForReader } from '@/lib/affiliates/readerPayment'

export default function ArticlePartnerCard({ value, language, country, pageSlug }) {
    const provider = value?.provider
    if (!provider?.code || provider.active === false) return null
    // EKTA только EN, Cherehapa только RU (решение владельца 01.10.2026)
    if (!isProviderForReader(provider.code, language)) return null

    const href = buildProviderLink(provider, language, country, {
        pageSlug,
        position: 'blog-editorial-card',
    })
    if (!href || href === '#') return null

    const providerTitle = provider.title || provider.code
    const title = value.title || providerTitle
    const description = value.description || (language === 'ru'
        ? (provider.descriptionRu || provider.descriptionEn)
        : (provider.descriptionEn || provider.descriptionRu))
    const eyebrow = value.eyebrow || (language === 'ru' ? 'Подходит для этой поездки' : 'A useful option for this trip')
    const ctaLabel = value.ctaLabel || (language === 'ru' ? 'Проверить условия' : 'Check the offer')
    const disclosure = value.disclosure || (language === 'ru' ? 'Партнёрская ссылка' : 'Affiliate link')
    const benefits = Array.isArray(value.benefits) ? value.benefits.filter(Boolean).slice(0, 3) : []

    return (
        <OfferView as="aside" className="article-partner-card" aria-label={`${eyebrow}: ${providerTitle}`} provider={provider.code} vertical={provider.vertical} country={country} position="blog-editorial-card">
            <div className="article-partner-card-label">
                <TbRosetteDiscountCheck aria-hidden="true" />
                <span>{eyebrow}</span>
            </div>
            <div className="article-partner-card-main">
                {provider.logoUrl && (
                    <div className="article-partner-card-logo">
                        <Image
                            src={provider.logoUrl}
                            alt={provider.logoAlt || providerTitle}
                            width={52}
                            height={52}
                            className="object-contain"
                        />
                    </div>
                )}
                <div className="article-partner-card-copy">
                    <h3>{title}</h3>
                    {description && <p>{description}</p>}
                    {benefits.length > 0 && (
                        <ul>
                            {benefits.map((benefit, index) => <li key={`${benefit}-${index}`}>{benefit}</li>)}
                        </ul>
                    )}
                </div>
            </div>
            <div className="article-partner-card-foot">
                <span>{disclosure}</span>
                <AffiliateLink
                    href={href}
                    provider={provider.code}
                    vertical={provider.vertical}
                    country={country}
                    position="blog-editorial-card"
                    label={ctaLabel}
                    className="article-partner-card-cta"
                >
                    {ctaLabel} <TbArrowUpRight aria-hidden="true" />
                </AffiliateLink>
            </div>
        </OfferView>
    )
}
